<template lang="pug">
payout-form-group
  template(v-slot:labelinner) &nbsp;
  .form-control-filtered-wrapper
    payout-form-checkbox(:value="value" @input="onUpdate" :disabled="disabled" :label="label")
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutFormCheckbox from "@/components/forms/basic/PayoutFormCheckbox.vue";

@Component({
  name: "PayoutFormGroupSectionCheckbox",
  components: {PayoutFormCheckbox, PayoutFormGroup},
})
export default class PayoutFormGroupSectionCheckbox extends Vue {
  @Prop({default: false})
  disabled!: boolean;

  @Prop({default: false})
  value: boolean

  @Prop({default: ''})
  label!: string;

  onUpdate($event: any) {
    this.$emit('input', $event);
  }
}
</script>

<style scoped>

</style>
